export { GlobalBlock, type GlobalContainerBlockProps } from "./GlobalBlock";
